import { useObservable } from '@mindspace-io/react';
import { sessionQuery, sessionStore } from './SessionStore';
import { facade } from './SessionFacade';

export function useAuthStatus() {
  const [isLoggedIn] = useObservable(
    sessionQuery.loggedIn$,
    sessionStore.getValue().isLoggedIn
  );

  return isLoggedIn;
}

export function useSessionStoreLoading() {
  const [isLoading] = useObservable(sessionQuery.loading$, true);

  return isLoading;
}

export function useSessionFacade() {
  return facade;
}

export function useSessionStoreError() {
  const [error] = useObservable(sessionQuery.error$, null);

  return error;
}
